import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sToast } from "sonner"
import { Log } from "@/utils/logger"

// Wrap sonner toast to add structured logging
const toast = Object.assign(
  (message: string) => {
    Log.toast("Info", message)
    return sToast(message)
  },
  {
    success: (message: string, opts?: any) => {
      Log.toast("Success", message, opts)
      return sToast.success(message, opts)
    },
    error: (message: string, opts?: any) => {
      Log.toast("Error", message, opts)
      return sToast.error(message, opts)
    },
    info: (message: string, opts?: any) => {
      Log.toast("Info", message, opts)
      return sToast.info ? sToast.info(message, opts) : sToast(message)
    },
    warning: (message: string, opts?: any) => {
      Log.toast("Warning", message, opts)
      // Some sonner versions use 'warning' or 'warn'
      return (sToast as any).warning ? (sToast as any).warning(message, opts) : (sToast as any).warn?.(message, opts) ?? sToast(message)
    },
    dismiss: (id?: string | number) => sToast.dismiss(id),
    promise<T>(promise: Promise<T>, messages: { loading: string; success: string; error: string }) {
      Log.toast("Info", messages.loading)
      return sToast.promise(promise, {
        loading: messages.loading,
        success: (val: any) => {
          Log.toast("Success", messages.success, val)
          return messages.success
        },
        error: (err: any) => {
          Log.toast("Error", messages.error, err)
          return messages.error
        },
      })
    },
  }
)

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
